import React from 'react';
import { useExtendableListPagination } from '@cp/shared/pagination';
import { CATALOG_FEEDBACK_PAGINATION } from '@common/const/catalog/feedback';
import { FeedbacksList, FeedbacksListProps } from '@cp/entities/feedback';
import { coreCatalogFeedbacksApi } from 'src/entities/catalog';
import { CatalogFeedbacksProps } from './types';

export const CatalogFeedbacks: React.FC<CatalogFeedbacksProps> = ({ catalogType, careerId, cityId, productName }) => {
  const { items, isLoading, canLoadMore, onLoadMore, additionalData } = useExtendableListPagination({
    parameters: {
      type: catalogType,
      cityId,
      careerId,
      pagination: CATALOG_FEEDBACK_PAGINATION,
    },
    query: coreCatalogFeedbacksApi.endpoints.getList,
  });

  const { averageRating, totalCount } = additionalData ?? {};

  const viewProps: FeedbacksListProps = {
    productName,
    totalCount,
    averageRating,
    items,
    isLoading,
    onLoadMore,
    canLoadMore,
    itemLayoutType: 'card',
    hideTitle: true,
  };

  return <FeedbacksList {...viewProps} />;
};
